import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';
import { pageCommon } from '@editor2/styles/page';

export const pageElementsPage = css`
	${pageCommon}

	.tocTabs {
		a {
			color: ${colors.mainText};
			border-radius: 0;
		}

		.nav-link.disabled {
			background-color: ${colors.background};
		}
	}

	.nav-tabs .nav-link.active {
		border-top-color: white;
	}

	.badge {
		margin-left: 10px;
	}
`;

export const pageEditorContainer = css`
	padding: 30px 40px;
	font-size: 14px;

	.pageNumber {
		width: 150px;
	}

	.pageCheckbox {
		label {
			font-size: 12px;
			color: ${colors.infoText};
		}
	}

	.pageName {
		font-weight: 600;
		margin-bottom: 30px;
	}

	.pageTypeSelect {
		width: 200px;
	}

	.pageImageContainer {
		display: flex;
		justify-content: center;
		margin-bottom: 5px;

		.pageImage {
			height: 125px;
		}
	}
`;

export const pageSettings = css`
	padding: 30px 40px;
	font-size: 14px;

	.pageTypeSelect {
		width: 200px;
	}
`;

export const contentTabStyle = css`
	padding: 20px 40px;
`;

export const addElementsBlock = css`
	display: flex;
	padding-bottom: 10px;
	margin-bottom: 20px;
	border-bottom: 1px solid ${colors.border};

	.title {
		color: ${colors.secondaryText};
		font-weight: 600;
	}

	.elements {
		display: flex;
		flex-wrap: wrap;

		button {
			margin-left: 10px;
			margin-bottom: 5px;
			font-size: 12px;
			padding: 5px;
			border-color: ${colors.border};

			:hover {
				color: ${colors.mainText};
				border-color: ${colors.border};
				background-color: ${colors.background};
			}
		}
	}
`;

export const toolsBlock = css`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-bottom: 20px;

	button {
		margin-left: 15px;
		font-size: 14px;
		border-color: ${colors.border};

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}

		svg {
			margin-right: 5px;
		}
	}
`;

export const contentBlock = css`
	.collapseIcon {
		transition-duration: 500ms;
	}

	.collapseIconRotate {
		transform: rotate(-90deg);
		transition-duration: 500ms;
	}

	.collapseIconHidden {
		visibility: hidden;
	}

	.listHidden {
		display: none;
	}

	.listShown {
		display: block;
	}
`;

export const headerContainer = css`
	font-weight: 600;
	line-height: 1.2;
	background-color: ${colors.background};
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
	cursor: grab;
	position: relative;
	margin-left: 35px;

	.headerBlock {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.headerText {
		padding: 12px 0 12px 16px;
		flex: 1;

		a {
			color: ${colors.mainText};
		}

		a:hover {
			cursor: pointer;
			text-decoration: underline;
		}

		.type {
			color: ${colors.secondaryText};
		}
	}

	.preview {
		padding: 0 16px 6px;
		margin-top: -6px;
		font-size: 12px;
		font-weight: 100;
		color: ${colors.infoText};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const elementOptions = css`
	padding: 12px 16px 12px 0;

	svg {
		cursor: pointer;
		margin-left: 10px;
	}

	.optionsIcon {
		position: relative;
	}

	.elementDropdown {
		position: absolute;
		top: -12px;
		left: 45px;
		z-index: 1;
		font-weight: 100;
		background-color: ${colors.background};
		width: max-content;
		cursor: default;
	}

	.dropdownItem {
		:hover {
			text-decoration: underline;
			cursor: pointer;
		}
	}
`;

export const elementContainer = css`
	margin-bottom: 15px;

	:hover {
		.menu {
			display: flex;
		}
	}

	.menu {
		position: absolute;
		left: -43px;
		top: 13px;
		padding: 0 10px;
		display: none;
		color: #6c757d;

		button {
			padding: 0;
		}

		svg:hover {
			background-color: ${colors.background};
			cursor: pointer;
		}
	}

	.elementBody {
		margin-left: 35px;
	}
`;

export const indent = css`
	margin-left: 35px;
	border-left: 1px solid ${colors.background};
`;
